<section class="content-section">

  <div *ngIf="chargement" class="bilan-loading">
    <div class="spinner"></div>
  </div>

  <div *ngIf="erreur" class="alert alert-danger">{{ erreur }}</div>

  <ng-container *ngIf="!chargement && stats">

    <!-- ── Hero palier ───────────────────────────────────────────────── -->
    <div class="palier-hero" [style.--palier-color]="palierCouleur">
      <div class="palier-left">
        <div class="palier-emoji">{{ stats.palier.emoji || '⭐' }}</div>
        <div class="palier-info">
          <div class="palier-nom">{{ stats.palier.label }}</div>
          <div class="palier-sous">
            <ng-container *ngIf="stats.palier.restantes > 0">
              {{ stats.palier.restantes }} courses pour le niveau suivant
            </ng-container>
            <ng-container *ngIf="stats.palier.restantes === 0">
              Niveau maximum atteint 🎉
            </ng-container>
          </div>
        </div>
      </div>
      <div class="palier-stats">
        <div class="palier-stat">
          <span class="palier-stat-val">{{ stats.coursesLivrees }}</span>
          <span class="palier-stat-lab">Courses livrées</span>
        </div>
        <div class="palier-stat">
          <span class="palier-stat-val">{{ stats.noteMoyenne?.toFixed(1) || '—' }}</span>
          <span class="palier-stat-lab">Note / {{ stats.nbAvis }} avis</span>
        </div>
      </div>
    </div>

    <!-- Barre de progression -->
    <div class="progress-wrap">
      <div class="progress-bar-bg">
        <div class="progress-bar-fill" [style.width.%]="progressPct" [style.background]="palierCouleur"></div>
      </div>
      <span class="progress-pct">{{ progressPct }}%</span>
    </div>

    <!-- ── Bilan du mois ─────────────────────────────────────────────── -->
    <h3 class="section-title">Mon bilan — {{ moisLabel }}</h3>

    <div class="bilan-cards">

      <div class="bilan-card">
        <div class="bilan-card-icon" style="background:#e0f2fe; color:#0284c7">
          <i class="fal fa-box-check"></i>
        </div>
        <div class="bilan-card-body">
          <div class="bilan-card-val">{{ stats.mois.coursesLivrees }}</div>
          <div class="bilan-card-lab">Livraisons ce mois</div>
          <div class="bilan-card-proj">
            → {{ stats.mois.coursesProjetees }} prévues en fin de mois
          </div>
        </div>
      </div>

      <div class="bilan-card">
        <div class="bilan-card-icon" style="background:#fef9c3; color:#ca8a04">
          <i class="fal fa-coins"></i>
        </div>
        <div class="bilan-card-body">
          <div class="bilan-card-val">{{ gainsMoisFormates }} FCFA</div>
          <div class="bilan-card-lab">Gains ce mois</div>
          <div class="bilan-card-proj">
            → {{ gainsProjectesFormates }} FCFA prévus en fin de mois
          </div>
        </div>
      </div>

      <div class="bilan-card bilan-card-highlight" [style.--hl-color]="palierCouleur">
        <div class="bilan-card-icon" [style.background]="palierCouleur + '22'" [style.color]="palierCouleur">
          <i class="fal fa-gift"></i>
        </div>
        <div class="bilan-card-body">
          <div class="bilan-card-val">{{ primeProjeteeFormatee }} FCFA</div>
          <div class="bilan-card-lab">Prime projetée fin de mois</div>
          <div class="bilan-card-proj">
            <ng-container *ngIf="stats.palier.primeFixe > 0 || stats.palier.primePct > 0">
              Prime fixe {{ stats.palier.primeFixe | number:'1.0-0' }} FCFA
              <ng-container *ngIf="stats.palier.primePct > 0">
                + {{ stats.palier.primePct }}% du CA
              </ng-container>
            </ng-container>
            <ng-container *ngIf="stats.palier.primeFixe === 0 && stats.palier.primePct === 0">
              Aucune prime configurée pour ce niveau
            </ng-container>
          </div>
        </div>
      </div>

    </div>

    <!-- Avancement du mois -->
    <div class="mois-avancement">
      <span class="text-secondary">Avancement du mois :</span>
      <strong>{{ stats.mois.jourAujourdhui }}/{{ stats.mois.joursTotal }} jours</strong>
      <div class="mois-bar-bg">
        <div class="mois-bar-fill"
             [style.width.%]="(stats.mois.jourAujourdhui / stats.mois.joursTotal * 100)">
        </div>
      </div>
      <span class="text-secondary" style="font-size:12px">
        Projection basée sur votre rythme actuel.
      </span>
    </div>

  </ng-container>

</section>
